var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0236 16.037C30.0236 24.1836 23.4149 30.7882 15.2618 30.7882C7.10877 30.7882 0.5 24.1836 0.5 16.037C0.5 7.89045 7.10877 1.28577 15.2618 1.28577C23.4149 1.28577 30.0236 7.89045 30.0236 16.037Z",
    stroke: "#F6F5F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7780_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2443 22.1549H8.28463V12.6239H11.2443V22.1549ZM9.76289 11.3238C8.81647 11.3238 8.04883 10.5399 8.04883 9.59345C8.04883 9.13886 8.22942 8.70288 8.55086 8.38143C8.87231 8.05998 9.30829 7.87939 9.76289 7.87939C10.2175 7.87939 10.6535 8.05998 10.9749 8.38143C11.2964 8.70288 11.4769 9.13886 11.4769 9.59345C11.4769 10.5399 10.709 11.3238 9.76289 11.3238ZM22.3215 22.1549H19.3682V17.5153C19.3682 16.4095 19.3459 14.9915 17.8294 14.9915C16.2906 14.9915 16.0548 16.1929 16.0548 17.4356V22.1549H13.0983V12.6239H15.9369V13.924H15.9783C16.3734 13.1752 17.3387 12.3849 18.7787 12.3849C21.774 12.3849 22.3247 14.3574 22.3247 16.9194V22.1549H22.3215Z",
    fill: "#F6F5F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7780_1174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3153,
    height: 16.3153,
    fill: "white",
    transform: "translate(7.0293 7.87939)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.63ae934373a52de31477fd35a4d5c841.svg";
export { ForwardRef as ReactComponent };